<script setup lang="ts">
import SourceInput from '@components/form/input-base-components/source-input.vue';
import {
    ModelValueEmitsType, ModelValuePropsInterface,
    useModelValueComposable,
} from '@components/form/compsables/model-value-composable.js';
import { FocusProps, useFocusComposable } from '@components/form/compsables/focus-composable.js';
import { useAttrs } from 'vue';
import { useIntRef } from '@src/application/composables/int-ref-composable.js';
import { useSingleRefComposable } from '@src/application/composables/single-ref-composable.js';
import {
    FormPartEmitsType,
    FormPartProps,
    useFormPartComposable,
} from '@src/form/composables/form-part-composable.js';

defineProps<FormPartProps & ModelValuePropsInterface<number|null> & FocusProps>();

defineEmits<FormPartEmitsType & ModelValueEmitsType<number|null>>();

const { setSingleTemplateRef, singleRef } = useSingleRefComposable<InstanceType<typeof SourceInput>>();
const { modelValue, exposes: modelValueExposes } = useModelValueComposable<number|null>(validate);
function validate() {
    if (modelValue.value === null) {
        return true;
    }

    if (isNaN(modelValue.value)) {
        return 'Das ist keine valide Ganzzahl.';
    }

    return true;
}

const { view } = useIntRef(modelValue);
const { submit, validationMessage, exposes: formPartExposes } = useFormPartComposable(modelValue, validate);
const { exposes: focusExposes } = useFocusComposable(singleRef);
defineExpose(
    {
        ...focusExposes,
        ...formPartExposes,
        ...modelValueExposes,
        selectText: () => singleRef.value?.selectText(),
    },
);
const attrs = useAttrs();
</script>

<template>
    <SourceInput
        :ref="setSingleTemplateRef"
        v-model="view"
        :form="form"
        v-bind="attrs"
        :name="name"
        :validation-message="validationMessage"
        @submit="submit"
    />
</template>
